import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../../components/Box';
import { Card } from '../../../../components/Card';
import { FormField } from '../../../../components/FormFields';
import { InvoiceSubjectContainer } from '../InvoiceSubject/InvoiceSubjectContainer';
import { addInvoiceSubject, removeInvoiceSubject, updateInvoiceSubject } from '../../actions';
import { INVOICE_DIRECTIONS, INVOICE_SUBJECT_TYPES } from '../../constants';

const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }

  div.wide_card {
    width: 100%;
  }

  .status-label {
    width: fit-content;
  }
`;

const STATE = {
  email: false,
};
/* eslint-disable react/prefer-stateless-function */
class InvoiceSubjectsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get invoiceStatus() {
    return this.props.invoice?.status?.name ?? 'OPEN';
  }

  get type() {
    return this.props.invoice?.type?.toUpperCase() ?? 'INVOICE';
  }

  get extraCosts() {
    const subjects = this.props.invoice?.invoiceSubjects?.filter(
      subject => subject.type === INVOICE_SUBJECT_TYPES.COST || subject.type === INVOICE_SUBJECT_TYPES.PRODUCT,
    );
    return subjects;
  }

  onSaveSubject(subject) {
    const subjectId = subject.id;
    console.log(subject, 'SUBJECT!!!');
    if (!subject?.costType) {
      return;
    }

    if (!subjectId) {
      this.props.addInvoiceSubject(subject, result => {});
      return;
    }

    this.props.updateInvoiceSubject(subject, subjectId, result => {});
  }

  onDeleteSubject(subjectId) {
    // if (this.props.invoice?.subjectType !== INVOICE_SUBJECT_TYPES.PRODUCT) return;
    this.props.removeInvoiceSubject(subjectId, data => {
      if (Array.isArray(data.invoiceSubjects)) {
        this.setState((prev, props) => {
          return { ...prev, invoiceSubjects: data.invoiceSubjects };
        });
      }
    });
  }

  render() {
    const invoice = this.props.invoice;
    const company =
      invoice.direction == INVOICE_DIRECTIONS.INCOMING ? invoice?.incomingCompanyId : invoice?.outgoingCompanyId;
    return (
      <Card className={`vehicle-info-card info-card info`}>
        <Container width={window.innerWidth}>
          <h2>{this.lbl('invoice.details.extra_cost')}</h2>
          <VBox>
            <FormField>
              <InvoiceSubjectContainer
                onSaveSubject={this.onSaveSubject.bind(this)}
                onDeleteSubject={this.onDeleteSubject.bind(this)}
                vehicleId={this.props.vehicleId}
                incomingCompanyId={company}
                direction={invoice?.direction}
                items={this.extraCosts}
              />
            </FormField>
          </VBox>
        </Container>
      </Card>
    );
  }
}

InvoiceSubjectsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addInvoiceSubject(subject, callback) {
      dispatch(addInvoiceSubject(subject, ownProps.invoice?.id, callback));
    },
    updateInvoiceSubject(subject, subjectId, callback) {
      dispatch(updateInvoiceSubject(subject, ownProps.invoice?.id, subjectId, callback));
    },
    removeInvoiceSubject(subjectId, callback) {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoice?.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceSubjectsCard = compose(withConnect, withRouter)(InvoiceSubjectsCardComp);
